import React from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

import PaiTextField from 'features/ui/base-components/pai-text-field';
import { BasicActionDialog } from 'features/ui/base-dialogs';

interface Props {
  open: boolean;
  loading: boolean;
  tagName: string;

  handleTagNameChange(event: React.ChangeEvent<HTMLInputElement>): void;
  handleClose(): void;
  handleEditTag(): void;
}

const EditTagDialog: React.FC<Props> = ({
  open,
  loading,
  tagName,
  handleTagNameChange,
  handleClose,
  handleEditTag
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <BasicActionDialog
      open={open}
      loading={loading}
      dialogTitle={t('renameTag')}
      maxWidth="xs"
      proceedButtonText={t('save')}
      proceedButtonDisabled={tagName.trim() === ''}
      handleProceed={handleEditTag}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
    // Optionally override dialog styling props if needed:
    // dialogActionsStyle={classes.dialogActions}
    // dialogPaperStyle={classes.dialogPaper}
    >
      <Stack spacing={2} className={classes.dialogContent}>
        <PaiTextField
          value={tagName}
          placeholder={t('enterTagNamePlaceholder')}
          onChange={handleTagNameChange}
        />
      </Stack>
    </BasicActionDialog>
  );
};

const useStyles = makeStyles()(() => ({
  dialogContent: {
    // Example custom spacing or styling
    // marginTop: theme.spacing(1),
  },
  // If <BasicActionDialog> supports custom classes or style overrides:
  // dialogPaper: {
  //   borderRadius: '12px',
  //   backgroundColor: '#FFF',
  // },
  // dialogActions: {
  //   padding: theme.spacing(2),
  //   display: 'flex',
  //   justifyContent: 'flex-end',
  //   gap: theme.spacing(2),
  // },
}));

export default EditTagDialog;
